!(function () {
    "use strict";

    function removeDuplicateSwymIcons() {

        const productCards = document.querySelectorAll('grid-item');

        productCards.forEach(card => {

            const icons = card.querySelectorAll(
                '.swym-wishlist-collections-v2-container'
            );

            if (icons.length <= 1) return;

            // Keep first icon only
            icons.forEach((icon, index) => {

                if (index > 0) {
                    icon.remove();
                }

            });
        });
    }

    function initializeSwymCollections() {

        if (
            !window._swat ||
            !window._swat.collectionsApi ||
            !window.Shopify?.theme?.id
        ) {
            return;
        }

        removeDuplicateSwymIcons();

        // Init collections
        window._swat.collectionsApi.initializeCollections(
            window._swat,
            false,
            Shopify.theme.id
        );
        requestAnimationFrame(() => {
            removeDuplicateSwymIcons();
        });

        setTimeout(() => {
            removeDuplicateSwymIcons();
        }, 300);

        setTimeout(() => {
            removeDuplicateSwymIcons();
        }, 1000);
    }

    function e(e) {

        const t = e || {};

        this.settings = Object.assign(
            {
                method: "scroll",
                container: "#AjaxinateContainer",
                pagination: "#AjaxinatePagination",
                offset: 0,
                loadingText: "Loading",
                callback: null,
            },
            t
        );

        this.isLoading = false;

        this.addScrollListeners =
            this.addScrollListeners.bind(this);

        this.checkIfPaginationInView =
            this.checkIfPaginationInView.bind(this);

        this.removeScrollListener =
            this.removeScrollListener.bind(this);

        this.containerElement =
            document.querySelector(
                this.settings.container
            );

        this.paginationElement =
            document.querySelector(
                this.settings.pagination
            );

        this.initialize();
    }

    // ------------------------------
    // INIT
    // ------------------------------

    e.prototype.initialize = function () {

        if (!this.containerElement) return;

        this.addScrollListeners();
    };

    // ------------------------------
    // ADD SCROLL LISTENERS
    // ------------------------------

    e.prototype.addScrollListeners = function () {

        this.removeScrollListener();

        if (!this.paginationElement) return;

        document.addEventListener(
            "scroll",
            this.checkIfPaginationInView
        );

        window.addEventListener(
            "resize",
            this.checkIfPaginationInView
        );

        window.addEventListener(
            "orientationchange",
            this.checkIfPaginationInView
        );
    };

    // ------------------------------
    // CHECK PAGINATION
    // ------------------------------

    e.prototype.checkIfPaginationInView = function () {

        if (
            !this.paginationElement ||
            this.isLoading
        ) {
            return;
        }

        const top =
            this.paginationElement
                .getBoundingClientRect().top -
            this.settings.offset;

        const bottom =
            this.paginationElement
                .getBoundingClientRect().bottom +
            this.settings.offset;

        if (
            top <= window.innerHeight &&
            bottom >= 0
        ) {

            this.nextPageLinkElement =
                this.paginationElement.querySelector("a");

            if (!this.nextPageLinkElement) return;

            this.removeScrollListener();

            this.nextPageLinkElement.innerText =
                this.settings.loadingText;

            this.nextPageUrl =
                this.nextPageLinkElement.href;

            this.isLoading = true;

            this.loadMore();
        }
    };

    // ------------------------------
    // LOAD MORE
    // ------------------------------

    e.prototype.loadMore = function () {

        this.request = new XMLHttpRequest();

        this.request.onreadystatechange = function () {

            if (!this.request.responseXML) return;

            if (
                this.request.readyState !== 4 ||
                this.request.status !== 200
            ) {
                return;
            }

            const newContainer =
                this.request.responseXML.querySelectorAll(
                    this.settings.container
                )[0];

            const newPagination =
                this.request.responseXML.querySelectorAll(
                    this.settings.pagination
                )[0];

            // Append products
            this.containerElement.insertAdjacentHTML(
                "beforeend",
                newContainer.innerHTML
            );

            // SINGLE SAFE SWYM INIT
            setTimeout(() => {
                initializeSwymCollections();
            }, 300);

            // Reset loading state
            this.isLoading = false;

            // Update pagination
            if (typeof newPagination === "undefined") {

                this.paginationElement.innerHTML = "";

            } else {

                this.paginationElement.innerHTML =
                    newPagination.innerHTML;

                this.addScrollListeners();
            }

        }.bind(this);

        this.request.open(
            "GET",
            this.nextPageUrl
        );

        this.request.responseType = "document";

        this.request.send();
    };

    // ------------------------------
    // REMOVE LISTENERS
    // ------------------------------

    e.prototype.removeScrollListener = function () {

        document.removeEventListener(
            "scroll",
            this.checkIfPaginationInView
        );

        window.removeEventListener(
            "resize",
            this.checkIfPaginationInView
        );

        window.removeEventListener(
            "orientationchange",
            this.checkIfPaginationInView
        );
    };

    // ------------------------------
    // CUSTOM ELEMENT
    // ------------------------------

    if (!customElements.get("ajaxinate-items")) {

        customElements.define(
            "ajaxinate-items",

            class extends HTMLElement {

                connectedCallback() {

                    const id =
                        this?.dataset.ajaxinateId;

                    const container =
                        `#AjaxinateLoop[data-ajaxinate-id="${id}"]`;

                    const pagination =
                        `#AjaxinatePagination[data-ajaxinate-id="${id}"]`;

                    if (this?.children.length > 0) {

                        new e({
                            container,
                            pagination,
                            method: "scroll",
                        });
                    }
                }
            }
        );
    }

    // ------------------------------
    // EXTRA GLOBAL DUPLICATE CLEANUP
    // ------------------------------

    let cleanupTimer;

    window.addEventListener('scroll', function () {

        clearTimeout(cleanupTimer);

        cleanupTimer = setTimeout(() => {
            removeDuplicateSwymIcons();
        }, 100);

    }, { passive: true });

})();
